import { MapPin, Star, ArrowRight, CalendarCheck } from "lucide-react";

const hotels = [
  {
    name: "Radisson Blu Niamey",
    city: "Niamey",
    rating: 4.6,
    stars: 4,
    price: "85 000",
    image: "/images/radisson.jpg",
  },
  {
    name: "Bravia Hôtel Niamey",
    city: "Niamey",
    rating: 4.3,
    stars: 4,
    price: "70 000",
    image: "/images/gaweye.png",
  },
  {
    name: "Hôtel Noom Niamey",
    city: "Niamey",
    rating: 4.2,
    stars: 4,
    price: "60 000",
    image: "/images/grand.jpg",
  },
  {
    name: "Hôtel Ténéré",
    city: "Agadez",
    rating: 4.5,
    stars: 4,
    price: "55 000",
    image: "/images/ee.jpeg",
  },
  {
    name: "Hôtel Aïr",
    city: "Arlit",
    rating: 4.1,
    stars: 4,
    price: "45 000",
    image: "/images/agadez.jpg",
  },
];

function Stars({ count }) {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={12}
          className={i <= count ? "text-amber-400 fill-amber-400" : "text-slate-200 fill-slate-200"}
        />
      ))}
    </div>
  );
}

export default function HotelsSection() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex items-end justify-between mb-5">
        <h2 className="text-xl md:text-2xl font-bold text-slate-800">Hôtels au Niger</h2>
        <button className="flex items-center gap-1 text-brand-600 hover:text-brand-700 text-sm font-semibold">
          Voir tous les hôtels <ArrowRight size={15} />
        </button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {hotels.map((h, i) => (
          <div
            key={i}
            className="bg-white border border-slate-100 rounded-xl overflow-hidden group hover:shadow-md transition-all flex flex-col"
          >
            <div className="aspect-video overflow-hidden bg-slate-100">
              <img
                src={h.image}
                alt={h.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-3 flex flex-col flex-1">
              <h3 className="font-semibold text-slate-800 text-sm leading-tight group-hover:text-brand-600 transition-colors">
                {h.name}
              </h3>
              <div className="flex items-center gap-1 mt-1 text-xs text-slate-500">
                <MapPin size={11} /> <span>{h.city}</span>
              </div>
              <div className="flex items-center justify-between mt-2">
                <Stars count={h.stars} />
                <span className="text-[10px] font-semibold text-emerald-700 bg-emerald-50 border border-emerald-100 px-1.5 py-0.5 rounded">
                  {h.rating}/5
                </span>
              </div>
              <p className="text-[10px] text-slate-400 mt-2">À partir de</p>
              <p className="font-bold text-slate-900 text-sm">
                {h.price} <span className="font-normal text-slate-500 text-xs">FCFA</span>
              </p>
              <button
                onClick={(e) => e.preventDefault()}
                className="mt-3 w-full inline-flex items-center justify-center gap-1.5 bg-brand-600 hover:bg-brand-700 text-white text-xs font-semibold py-2 rounded-lg transition-colors"
              >
                <CalendarCheck size={13} /> Réserver
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
